import "./customer-level.scss";

import { useUserIdentityContext } from "@core/services/user-identity.context";
import { GetUserLevelModel } from "@factory/model/query-model-quota-system";
import { RewardBalance } from "@factory/model/query-model-reward";
import { classNames } from "primereact/utils";

import ProgressBarWithLabel from "../centered-progress-bar/centered-progress-bar";

export interface CustomerLevelProps {
  avatar?: string;
  balance: RewardBalance;
  userLevel?: GetUserLevelModel;
}

export function CustomerLevel({
  avatar,
  balance,
  userLevel,
}: CustomerLevelProps) {
  // DECLARATIONS
  const { getClientFeatures } = useUserIdentityContext();
  const clientFeatures = getClientFeatures();

  // API DEFINITIONS

  // LOCAL FUNCTIONS

  // LOCAL RENDERS
  const valueTemplate = () => (
    <div className="text-xs font-semibold">
      {balance?.exp_points}/{balance?.next_level_points_cap}
    </div>
  );

  return (
    <div id="CustomerLevel" className="customer-level">
      <div className="flex items-center mb-2 space-x-2 w-full">
        <img src={avatar} className="w-10 h-10 rounded-full bg-gray-200" />
        <div>
          <h1 className="capitalize">
            {balance?.first_name} {balance?.last_name}
          </h1>
        </div>
      </div>
      <div className={classNames("grid grid-cols-1 gap-2", userLevel ? ("md:grid-cols-2") : null)}>
        <div>
          <p className="text-gray-600 mb-2">Rank: {balance?.level_name}</p>
          <div className="w-full flex flex-col items-center">
            <div className="w-full mb-2">
              <ProgressBarWithLabel
                ptClassName="h-5"
                current={balance?.exp_points}
                total={balance?.next_level_points_cap}
                unit="points"
                color="#5e17eb"
              />
            </div>
            {Math.round(balance?.next_level_points_cap - balance?.exp_points) > 0 ? (
              <p className="text-xs align-left mb-5 w-full text-gray-600">
                {Math.round(balance?.next_level_points_cap - balance?.exp_points)} to achieve{" "}
                {balance?.next_level_name}
              </p>
            ) : (
              <p className="text-xs align-left mb-5 w-full text-gray-600">
                You have achieved the highest rank!
              </p>
            )}
          </div>
        </div>
        {(clientFeatures?.featureQuota && userLevel) ? (
          <div>
            <p className="text-gray-600 mb-2">
              Tier: {userLevel?.current_level_name}
            </p>
            <div className="w-full mb-2">
              <ProgressBarWithLabel
                ptClassName="h-5"
                current={userLevel?.total_spent_current_period}
                total={(userLevel?.total_spent_current_period || 0) + (userLevel?.spending_needed_for_next_level || 0)}
                unit="spent"
                color="#fac150"
              />
            </div>
            <p className="text-xs w-full text-gray-600">
              Next Evaluation: {userLevel?.days_until_evaluation} days
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default CustomerLevel;
